var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Brazil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#4caf50"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeb3b",
    d: "M42,24L24,36L6,24l18-12L42,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M31,24c0,3.867-3.133,7-7,7s-7-3.133-7-7s3.133-7,7-7S31,20.133,31,24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.805,20.746c-0.34,0.645-0.574,1.348-0.699,2.09c2.254-0.277,8.379-0.563,13.535,3.375 C30.871,25.516,31,24.773,31,24c0,0,0-0.004,0-0.008C26.059,20.645,20.656,20.512,17.805,20.746z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Brazil);
export default __webpack_public_path__ + "static/media/icons8-brazil.2c6a785aa40622b723a8d84a907fe94a.svg";
export { ForwardRef as ReactComponent };